import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiHome, FiBook, FiShoppingBag, FiVideo, FiUser } from 'react-icons/fi';

const BottomNavigation = () => {
  const location = useLocation();

  const navItems = [
    {
      path: '/',
      label: 'Home',
      icon: FiHome,
    },
    {
      path: '/courses',
      label: 'Courses',
      icon: FiBook,
    },
    {
      path: '/my-courses',
      label: 'Purchase',
      icon: FiShoppingBag,
    },
    {
      path: '/live',
      label: 'Live',
      icon: FiVideo,
    },
    {
      path: '/profile',
      label: 'Profile',
      icon: FiUser,
    },
  ];

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50 md:hidden safe-area-bottom">
      <div className="grid grid-cols-5 h-[72px]">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center gap-0.5 transition-all duration-200 relative ${
                active
                  ? 'text-primary-500'
                  : 'text-gray-500 active:text-gray-700'
              }`}
            >
              <Icon
                className={`w-5 h-5 transition-transform ${
                  active ? 'scale-110' : ''
                }`}
              />
              <span
                className={`text-[10px] leading-tight font-medium mt-0.5 ${
                  active ? 'font-semibold' : ''
                }`}
              >
                {item.label}
              </span>
              {active && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-10 h-0.5 bg-primary-500 rounded-b-full"></div>
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation;
